// import React, { useState } from "react";
// import { Button, Paper, Table, TableBody, TableCell } from "@mui/material";
// import { TableContainer, TableHead, TableRow } from "@mui/material";
// import { RFTfeature } from "../../features/RFTfeature";
// import ShowItemsDetails from "../../inventory/ShowItemsDetails";

// function Stock({ items, onChange }) {
//   const [open, setOpen] = useState(false);
//   const [selected, setSelected] = useState("");

//   const toggle = (title = null) => {
//     setSelected(title);
//     setOpen((prev) => !prev);
//   };

//   return (
//     <TableContainer component={Paper}>
//       <Table aria-label="customized table">
//         <TableHead>
//           <TableRow>
//             <TableCell>Selected</TableCell>
//             <TableCell>Items Name</TableCell>
//             <TableCell>Cost Price</TableCell>
//             <TableCell>Sale Price</TableCell>
//             <TableCell>Total Quantity</TableCell>
//             <TableCell></TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {items?.map((item, i) => {
//             let qty = parseFloat(item.quantity);
//             let itemQty = qty % 1 === 0 ? qty : qty.toFixed(3);
//             let decimal = itemQty - Math.floor(itemQty);
//             return (
//               <TableRow key={i}>
//                 <TableCell component="th" scope="row">
//                   <input
//                     type="checkbox"
//                     defaultChecked=""
//                     onChange={() => onChange(item)}
//                   />
//                 </TableCell>
//                 <TableCell component="th" scope="row" className="fs-8">
//                   {item?.name}
//                 </TableCell>
//                 <TableCell component="th" scope="row" className="fs-8">
//                   {item.pricePerPiece || item?.costPrice}
//                 </TableCell>
//                 <TableCell component="th" scope="row" className="fs-8">
//                   {item?.price}
//                 </TableCell>
//                 {item.weightType == true ? (
//                   <TableCell component="th" scope="row">
//                     {parseFloat(item.weight) % 1 === 0
//                       ? item.weight
//                       : parseFloat(item.weight).toFixed(3)}
//                   </TableCell>
//                 ) : RFTfeature() && item.unit == "Role" ? (
//                   <TableCell
//                     component="th"
//                     scope="row"
//                     sx={{ dispaly: "flex", flexDirection: "column" }}
//                   >
//                     <p style={{ margin: "0px", padding: "0px" }}>
//                       Role : {parseInt(item?.quantity)}
//                     </p>
//                     <p style={{ margin: "0px", padding: "0px" }}>
//                       RFT : {parseInt(decimal * 328)}
//                     </p>
//                   </TableCell>
//                 ) : (
//                   <TableCell component="th" scope="row" className="fs-8">
//                     {itemQty}
//                   </TableCell>
//                 )}
//                 <TableCell component="th" scope="row" className="fs-8">
//                   <Button
//                     size="small"
//                     variant="contained"
//                     onClick={() => toggle(item.name)}
//                     sx={{ textTransform: "none" }}
//                   >
//                     Details
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             );
//           })}
//         </TableBody>
//       </Table>

//       {open && <ShowItemsDetails onClose={toggle} name={selected} />}
//     </TableContainer>
//   );
// }

// export default Stock;

import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  console.log("rowwww", row);
  console.log("row.itemStockValue",   row.itemStockValue);

  const costPriceBatchInside =
    row?.batchNumber?.[0]?.newItem?.costPrice ?? null;
  const salePriceBatchInside = row?.batchNumber?.[0]?.newItem?.price ?? null;
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {row.batchNumber.length > 0 ? (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        ) :<TableCell> </TableCell>
 }

        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right">
          {row.costPrice || costPriceBatchInside}
        </TableCell>
        <TableCell align="right">{row.price || salePriceBatchInside}</TableCell>
        <TableCell align="right">{row.quantity}</TableCell>
        <TableCell align="right">{row.totalBoxes}</TableCell>
        <TableCell align="left">{row.itemStockValue}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Items Name	</TableCell>
                    <TableCell>Cost Price	</TableCell>
                    <TableCell align="right">Sale Price</TableCell>
                    <TableCell align="right">Total Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.batchNumber?.map((historyRow) => {
                    console.log('historyRow', historyRow)
                 return(
                    <TableRow key={historyRow?._id || Math.random()}>
                      <TableCell component="th" scope="row">
                        {row?.name}
                      </TableCell>
                      <TableCell>{historyRow?.newItem?.costPrice}</TableCell>
                      <TableCell align="right">{historyRow?.newItem?.price}</TableCell>
                      <TableCell align="right">
                        {historyRow?.quantity}
                      </TableCell>
                    </TableRow>
                    )
})}
                </TableBody>
              </Table> */}

              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Items Name</TableCell>
                    <TableCell  align="center">Cost Price</TableCell>
                    <TableCell align="center">Sale Price</TableCell>
                    <TableCell align="center">Total Quantity</TableCell>
                    <TableCell align="center">Total Boxes</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.batchNumber?.map((historyRow) => {
                    console.log("historyRow:", historyRow);
                    return (
                      <TableRow key={historyRow?._id || Math.random()}>
                        <TableCell component="th" scope="row">
                          {row?.name || "N/A"}
                        </TableCell>
                        <TableCell>
                          {historyRow?.newItem?.costPrice || "N/A"}
                        </TableCell>
                        <TableCell align="right">
                          {historyRow?.newItem?.price || "N/A"}
                        </TableCell>
                        <TableCell align="right">
                          {historyRow?.quantity || 0}
                        </TableCell>
                        <TableCell align="right">
                          {historyRow?.totalBoxes || 0}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

export default function StockPrint({ onChange,stockReport }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
          <TableCell align="center" >#</TableCell>
          <TableCell >Items Name </TableCell>
            <TableCell align="center">Cost Price </TableCell>
            <TableCell align="center">Sale Price </TableCell>
            <TableCell align="center">Total Quantity </TableCell>
            <TableCell align="center">Total Ctn </TableCell>
            <TableCell align="center">Stock Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stockReport?.map((row) => (
            <Row key={row?._id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
